import { ReactComponent } from './number-1-xl.svg';
export const Number1IconXl = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=number-1-xl.js.map